import swal from "sweetalert";
import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { API_DOMAIN, API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import FormArea from "../components/form-areas";
import { activarArea, inactivarArea } from "../../services/areas-service";

const Areas = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalArea = useModal({
        title: "Crear area",
        data: { area: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("areasCrear")) {
        tableButtons.push({
            titleAttr: "Crear area",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalArea.open({
                    title: "Crear area",
                    data: { area: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("areasEditar")) {
        tableButtons.push({
            titleAttr: "Editar area",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalArea.open({
                    title: "Editar area",
                    data: { area: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("areasInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar area",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta area?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado el area");
                        break;
                    case "eliminar": {
                        const resp = await inactivarArea(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el area"
                            );
                        }

                        sweetAl.success(
                            "El area fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("areasActivar")) {
        tableButtons.push({
            titleAttr: "Activar area",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta area?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado el area");
                        break;
                    case "activar": {
                        const resp = await activarArea(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el area"
                            );
                        }

                        sweetAl.success("El area fue activada correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "areas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaCargos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/areas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de los areas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "descripcion" },
            { data: "email" },
            { data: "img" },
            { data: "color" },
            { data: "vista" },
            { data: "status" },
        ],
        columnDefs: [
            {
                target: [4],
                createdCell: function (td, cellData) {
                    const path = `${API_DOMAIN}${cellData}`;
                    td.innerHTML = `
                        <img
                            src='${path}'
                            class='rounded-circle'
                            width='50px'
                            height='50px'
                            onerror="this.src='img/logo_csr_big.png'"
                        />
                    `;
                },
            },
            {
                targets: [5],
                createdCell: (td, cellData) => {
                    td.innerHTML = `
                        <div style="width: 30px; height: 30px; background-color: ${cellData}"></div>
                    `;
                },
            },
            {
                targets: 6,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Si" : "No";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: 7,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Áreas
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaCargos">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Descripcion</th>
                            <th>Email</th>
                            <th>Imagen</th>
                            <th>Color</th>
                            <th>Vista</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormArea modalState={modalArea} onSave={onSave} />
        </ContentWrapper>
    );
};

export default Areas;
